const STYLE_ID = 'antic-shop-pay-lockup';
const SHOP_PAY_INK = 'var(--color-foreground, #1f1f1f)';

const LOCKUP_CSS =
  ':host{' +
  'display:inline-flex!important;' +
  'justify-content:flex-end!important;' +
  'align-items:center!important;' +
  'width:auto!important;' +
  'max-width:100%!important;' +
  'min-width:0!important;' +
  'flex:0 0 auto!important;' +
  'margin-inline-start:auto!important;' +
  'line-height:1!important;' +
  'color:' + SHOP_PAY_INK + '!important' +
  '}' +
  '#antic-shop-pay-glue svg,' +
  '#antic-shop-pay-glue svg :not([fill="none"]),' +
  '#shopify-installments-content svg:not(#shopify-installments-cta svg),' +
  '#shopify-installments-content svg:not(#shopify-installments-cta svg) :not([fill="none"]){' +
  'fill:currentColor!important;' +
  'color:currentColor!important;' +
  'stroke:none!important' +
  '}' +
  '#shopify-installments-cta,' +
  '#shopify-installments-cta svg{' +
  'color:currentColor!important;' +
  'opacity:.5!important;' +
  'font-weight:400!important' +
  '}' +
  '#shopify-installments,' +
  '#antic-shop-pay-shell,' +
  '#shopify-installments-content,' +
  '#antic-shop-pay-shell p,' +
  '#antic-shop-pay-shell span,' +
  '#antic-shop-pay-shell div,' +
  '#shopify-installments p,' +
  '#shopify-installments span,' +
  '#shopify-installments div{' +
  'display:inline-flex!important;' +
  'flex-flow:row nowrap!important;' +
  'align-items:center!important;' +
  'justify-content:flex-start!important;' +
  'gap:.15em!important;' +
  'width:auto!important;' +
  'max-width:none!important;' +
  'min-width:0!important;' +
  'flex:0 0 auto!important;' +
  'flex-grow:0!important;' +
  'margin:0!important;' +
  'margin-inline:0!important;' +
  'padding:0!important;' +
  'white-space:nowrap!important;' +
  'overflow:visible!important;' +
  'line-height:1!important' +
  '}' +
  '.justify-between,' +
  '.w-full,' +
  '.flex-1,' +
  '.mx-auto,' +
  '.ml-auto,' +
  '.mr-auto{' +
  'justify-content:flex-start!important;' +
  'width:auto!important;' +
  'flex:0 0 auto!important;' +
  'margin-left:0!important;' +
  'margin-right:0!important' +
  '}' +
  '#antic-shop-pay-shell svg,' +
  '#shopify-installments svg{' +
  'display:block!important;' +
  'height:1em!important;' +
  'width:auto!important;' +
  'max-height:1em!important;' +
  'max-width:none!important;' +
  'flex:0 0 auto!important;' +
  'flex-shrink:0!important;' +
  'margin:0!important;' +
  'padding:0!important;' +
  'translate:none!important;' +
  'scale:none!important;' +
  'transform:translateY(0.12em)!important' +
  '}' +
  '#shopify-installments-cta{' +
  'display:inline-flex!important;' +
  'align-items:center!important;' +
  'justify-content:center!important;' +
  'flex:0 0 auto!important;' +
  'width:1em!important;' +
  'height:1em!important;' +
  'min-width:1em!important;' +
  'min-height:1em!important;' +
  'margin:0 0 0 calc(0.15em - 2px)!important;' +
  'padding:0!important;' +
  'border:0!important;' +
  'background:transparent!important;' +
  'overflow:visible!important;' +
  'visibility:visible!important;' +
  'opacity:1!important;' +
  'position:relative!important;' +
  'z-index:3!important;' +
  'pointer-events:auto!important;' +
  'line-height:0!important;' +
  'translate:none!important;' +
  'scale:none!important;' +
  'transform:translateY(0.12em)!important' +
  '}' +
  '#shopify-installments-content{' +
  'justify-content:flex-start!important;' +
  'width:auto!important;' +
  'flex:0 0 auto!important;' +
  'flex-grow:0!important' +
  '}' +
  '#antic-shop-pay-glue{' +
  'display:inline-flex!important;' +
  'flex-flow:row nowrap!important;' +
  'align-items:center!important;' +
  'justify-content:flex-start!important;' +
  'gap:.2em!important;' +
  'width:auto!important;' +
  'max-width:none!important;' +
  'flex:0 0 auto!important;' +
  'white-space:nowrap!important;' +
  'margin:0!important;' +
  'padding:0!important' +
  '}' +
  '#antic-shop-pay-glue > *,' +
  '#shopify-installments-content > *{' +
  'display:inline-flex!important;' +
  'flex:0 0 auto!important;' +
  'width:auto!important;' +
  'margin:0!important;' +
  'padding:0!important' +
  '}' +
  '#shopify-installments-cta svg{' +
  'display:block!important;' +
  'width:1em!important;' +
  'height:1em!important;' +
  'max-width:1em!important;' +
  'max-height:1em!important;' +
  'overflow:visible!important;' +
  'translate:none!important;' +
  'scale:none!important;' +
  'transform:none!important;' +
  'margin:0!important' +
  '}';

function getHosts() {
  return document.querySelectorAll('.cart__installments shopify-payment-terms');
}

function shrink(el) {
  if (!el || el.nodeType !== 1) return;
  if (el.id === 'shopify-installments-cta') return;
  el.style.setProperty('display', 'inline-flex', 'important');
  el.style.setProperty('flex-flow', 'row nowrap', 'important');
  el.style.setProperty('align-items', 'center', 'important');
  el.style.setProperty('justify-content', 'flex-start', 'important');
  el.style.setProperty('width', 'auto', 'important');
  el.style.setProperty('max-width', 'none', 'important');
  el.style.setProperty('min-width', '0', 'important');
  el.style.setProperty('flex', '0 0 auto', 'important');
  el.style.setProperty('flex-grow', '0', 'important');
  el.style.setProperty('margin-left', '0', 'important');
  el.style.setProperty('margin-right', '0', 'important');
  el.style.setProperty('padding-left', '0', 'important');
  el.style.setProperty('padding-right', '0', 'important');
  el.style.setProperty('white-space', 'nowrap', 'important');
}

function shopMark(root, cta) {
  const mark = root.querySelector('#shopify-installments-content svg');
  if (mark) return mark;
  const svgs = root.querySelectorAll('#shopify-installments svg');
  for (let i = 0; i < svgs.length; i++) {
    if (!cta || !cta.contains(svgs[i])) return svgs[i];
  }
  return null;
}

function glueCopyAndMark(root, cta) {
  const content = root.querySelector('#shopify-installments-content');
  const mark = shopMark(root, cta);
  const source = content || root.getElementById('antic-shop-pay-shell');
  if (!source || !mark) return;

  let glue = root.getElementById('antic-shop-pay-glue');
  if (!glue) {
    glue = document.createElement('span');
    glue.id = 'antic-shop-pay-glue';
  }
  shrink(glue);
  glue.style.setProperty('gap', '0.2em', 'important');

  let node = source.firstChild;
  while (node) {
    const next = node.nextSibling;
    if (node !== glue && node !== cta && !(cta && node.contains && node.contains(cta))) {
      glue.appendChild(node);
    }
    node = next;
  }
  if (!glue.contains(mark)) {
    const move =
      mark.parentElement && mark.parentElement !== source && mark.parentElement !== glue
        ? mark.parentElement
        : mark;
    if (move !== cta && !(cta && cta.contains(move))) glue.appendChild(move);
  }
  if (glue.parentNode !== source) {
    if (cta && cta.parentNode === source) source.insertBefore(glue, cta);
    else source.appendChild(glue);
  }

  shrink(source);
  Array.prototype.forEach.call(glue.querySelectorAll('*'), (child) => {
    if (cta && (child === cta || cta.contains(child))) return;
    if (child.tagName === 'svg') {
      child.style.setProperty('margin', '0', 'important');
      child.style.setProperty('flex', '0 0 auto', 'important');
      return;
    }
    shrink(child);
  });
}

function packLockup(root, cta) {
  const row = root.querySelector('#shopify-installments');
  if (!row) return;

  let shell = root.getElementById('antic-shop-pay-shell');
  if (!shell) {
    shell = document.createElement('span');
    shell.id = 'antic-shop-pay-shell';
  }
  shrink(shell);
  shell.style.setProperty('gap', '0.2em', 'important');

  let node = row.firstChild;
  while (node) {
    const next = node.nextSibling;
    if (node !== shell) shell.appendChild(node);
    node = next;
  }
  if (shell.parentNode !== row) row.appendChild(shell);
  if (cta && cta.parentElement !== shell) shell.appendChild(cta);

  shrink(row);
  Array.prototype.forEach.call(shell.querySelectorAll('*'), (child) => {
    if (child.id === 'shopify-installments-cta' || (cta && cta.contains(child))) return;
    shrink(child);
  });
  glueCopyAndMark(root, cta);
}

function paintInk(el, ink) {
  if (!el) return;
  const color = ink || SHOP_PAY_INK;
  el.style.setProperty('fill', color, 'important');
  el.style.setProperty('color', color, 'important');
  el.style.setProperty('stroke', 'none', 'important');
  Array.prototype.forEach.call(el.querySelectorAll('*'), (node) => {
    if (node.getAttribute && node.getAttribute('fill') === 'none') return;
    node.style.setProperty('fill', color, 'important');
    node.style.setProperty('color', color, 'important');
    node.style.setProperty('stroke', 'none', 'important');
  });
}

function hostInk(host) {
  const context = host?.closest('.cart-drawer__summary, .cart__summary-container, .cart__installments') || host;
  return (context && getComputedStyle(context).color) || SHOP_PAY_INK;
}

function matchParts(mark, cta, ink) {
  const size = '1em';
  if (mark) {
    mark.style.setProperty('height', size, 'important');
    mark.style.setProperty('max-height', size, 'important');
    mark.style.setProperty('width', 'auto', 'important');
    mark.style.setProperty('margin', '0', 'important');
    mark.style.setProperty('padding', '0', 'important');
    mark.style.setProperty('translate', 'none', 'important');
    mark.style.setProperty('scale', 'none', 'important');
    mark.style.setProperty('transform', 'translateY(0.12em)', 'important');
    paintInk(mark, ink);
  }
  if (cta) {
    cta.style.setProperty('display', 'inline-flex', 'important');
    cta.style.setProperty('align-items', 'center', 'important');
    cta.style.setProperty('justify-content', 'center', 'important');
    cta.style.setProperty('width', size, 'important');
    cta.style.setProperty('height', size, 'important');
    cta.style.setProperty('min-width', size, 'important');
    cta.style.setProperty('min-height', size, 'important');
    cta.style.setProperty('visibility', 'visible', 'important');
    cta.style.setProperty('opacity', '0.5', 'important');
    cta.style.setProperty('font-weight', '400', 'important');
    cta.style.setProperty('flex-shrink', '0', 'important');
    cta.style.setProperty('overflow', 'visible', 'important');
    cta.style.setProperty('margin-left', 'calc(0.15em - 2px)', 'important');
    cta.style.setProperty('translate', 'none', 'important');
    cta.style.setProperty('scale', 'none', 'important');
    cta.style.setProperty('transform', 'translateY(0.12em)', 'important');
    const ctaSvg = cta.querySelector('svg');
    if (ctaSvg) {
      ctaSvg.style.setProperty('width', size, 'important');
      ctaSvg.style.setProperty('height', size, 'important');
      ctaSvg.style.setProperty('max-width', size, 'important');
      ctaSvg.style.setProperty('max-height', size, 'important');
      ctaSvg.style.setProperty('transform', 'none', 'important');
      ctaSvg.style.setProperty('color', ink || SHOP_PAY_INK, 'important');
      ctaSvg.style.setProperty('opacity', '0.5', 'important');
      ctaSvg.style.setProperty('font-weight', '400', 'important');
    }
  }
}

function applyAlignment(host) {
  const wrap = host.closest('.cart__installments');
  const form = host.closest('form.payment-terms') || host.closest('form');

  host.style.setProperty('display', 'inline-flex', 'important');
  host.style.setProperty('align-items', 'center', 'important');
  host.style.setProperty('width', 'auto', 'important');
  host.style.setProperty('max-width', '100%', 'important');
  host.style.setProperty('min-width', '0', 'important');
  host.style.setProperty('flex', '0 0 auto', 'important');
  host.style.setProperty('justify-content', 'flex-end', 'important');
  host.style.setProperty('margin-inline-start', 'auto', 'important');

  if (wrap) {
    wrap.style.setProperty('display', 'flex', 'important');
    wrap.style.setProperty('align-items', 'center', 'important');
    wrap.style.setProperty('justify-content', 'flex-end', 'important');
    wrap.style.setProperty('width', '100%', 'important');
    wrap.style.setProperty('max-width', '100%', 'important');
    wrap.style.setProperty('min-width', '0', 'important');
    wrap.style.setProperty('flex', '0 0 auto', 'important');
    wrap.style.setProperty('margin-inline-start', 'auto', 'important');
    wrap.style.setProperty('text-align', 'right', 'important');
  }

  if (form) {
    form.style.setProperty('display', 'inline-flex', 'important');
    form.style.setProperty('align-items', 'center', 'important');
    form.style.setProperty('width', 'auto', 'important');
    form.style.setProperty('max-width', '100%', 'important');
    form.style.setProperty('min-width', '0', 'important');
    form.style.setProperty('flex', '0 0 auto', 'important');
    form.style.setProperty('margin', '0', 'important');
    form.style.setProperty('margin-inline-start', 'auto', 'important');
  }
}

function observe(host, root) {
  if (root._anticShopPayObserved) return;
  root._anticShopPayObserved = true;
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      injectHost(host);
    });
  }).observe(root, { childList: true, subtree: true });
}

function injectHost(host) {
  if (!host?.isConnected) return false;
  const root = host.shadowRoot;
  if (!root) return false;

  let cta = root.querySelector('#shopify-installments-cta');
  let mark = shopMark(root, cta);
  const row = root.querySelector('#shopify-installments');
  if (!mark && !cta && !row) return false;

  const shell = root.getElementById('antic-shop-pay-shell');
  const glue = root.getElementById('antic-shop-pay-glue');
  const packed =
    !!root.getElementById(STYLE_ID) &&
    !!shell &&
    !!row &&
    shell.parentNode === row &&
    (!cta || cta.parentElement === shell) &&
    !!glue &&
    (!mark || glue.contains(mark));

  if (packed) {
    glueCopyAndMark(root, cta);
    matchParts(shopMark(root, cta), root.querySelector('#shopify-installments-cta'), hostInk(host));
    applyAlignment(host);
    observe(host, root);
    return true;
  }

  let style = root.getElementById(STYLE_ID);
  if (!style) {
    style = document.createElement('style');
    style.id = STYLE_ID;
    root.appendChild(style);
  }
  style.textContent = LOCKUP_CSS;

  packLockup(root, cta);
  mark = shopMark(root, cta);
  cta = root.querySelector('#shopify-installments-cta');
  matchParts(mark, cta, hostInk(host));
  applyAlignment(host);
  observe(host, root);
  return !!(mark || cta);
}

function styleCartInstallments() {
  let ready = false;
  getHosts().forEach((host) => {
    if (injectHost(host)) ready = true;
  });
  return ready;
}

let scheduled = false;
function schedule() {
  if (scheduled) return;
  scheduled = true;
  requestAnimationFrame(() => {
    scheduled = false;
    styleCartInstallments();
  });
}

function observeLightDom() {
  if (document.documentElement.dataset.anticCartShopPayObserved === '1') return;
  document.documentElement.dataset.anticCartShopPayObserved = '1';
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
}

let tries = 0;
function attempt() {
  styleCartInstallments();
  observeLightDom();
  if (getHosts().length && styleCartInstallments()) return;
  if (++tries > 40) return;
  setTimeout(attempt, 250);
}

if (window.customElements?.whenDefined) {
  customElements.whenDefined('shopify-payment-terms').then(attempt);
} else {
  attempt();
}

document.addEventListener('DOMContentLoaded', attempt);
document.addEventListener('cart:update', () => {
  tries = 0;
  requestAnimationFrame(attempt);
});
document.addEventListener('cart-drawer:opened', () => {
  tries = 0;
  requestAnimationFrame(attempt);
});
